import React, { useCallback, useState } from 'react';
import IdleTimer from 'react-idle-timer';
import { SESSION_EXPIRATION_TIMEOUT, SESSION_INACTIVE_TIMEOUT } from '@/constants';
import IdleAlert from './idle-alert';
const INACTIVITY_CHECK_DEBOUNCE = 250;
export const InactivityMonitor = () => {
    const [isInactive, setIsInactive] = useState(false);
    const handleIdle = useCallback(() => {
        setIsInactive(true);
    }, []);
    const handleActive = useCallback(() => {
        setIsInactive(false);
    }, []);
    return (<React.Fragment>
      <IdleTimer debounce={INACTIVITY_CHECK_DEBOUNCE} timeout={SESSION_EXPIRATION_TIMEOUT - SESSION_INACTIVE_TIMEOUT} onIdle={handleIdle}/>
      <IdleAlert isInactive={isInactive} onActive={handleActive}/>
    </React.Fragment>);
};
export default InactivityMonitor;
